export default __webpack_public_path__ + "static/media/Logo.d8a7bc35.svg";